/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import cx from 'classnames';

import constants from '../../../utils/constants';
import PlpContext from '../../../templates/Plp/context';
import styles from './styles.module.scss';

const Footnotes = () => {
  const { KabbageCard, KabbageSimple } = constants;

  const handleClick = event => {
    event.preventDefault();
    window.scrollTo(0, 0);
  };

  return (
    <PlpContext.Consumer>
      {({ plpId = null, template = '' } = {}) => {
        const isSbaTemplate = ['SbaPost', 'SbaApply'].includes(template);

        const defaultListItems = (
          <>
            <li>All loans are subject to credit approval.</li>
            <li>
              Kabbage Funding can approve you in minutes for up to $200,000 when
              we are able to automatically obtain your business data and verify
              your bank account. Lines of credit over $200,000 require a manual
              review. In some situations, errors may occur during the sign up
              process, or we may need to send micro-deposits to confirm your
              bank account for security purposes. If this is the case, it may
              take up to several days to provide you access to funding.
            </li>
            <li>
              Not all loan term lengths are available to all customers.
              Customers can view their available term lengths after
              qualification.
            </li>
            <li>
              This is not a guarantee of qualification, but rather the minimum
              qualification criteria.
            </li>
            {// plpId 26753 refers to invoice2go
            plpId === 26753 && (
              <li>
                The <KabbageCard /> is issued by Republic Bank & Trust Company,
                member FDIC, pursuant to license by Visa U.S.A., Inc. See the
                Cardholder Agreement for Terms & Conditions including fee
                schedule details. See FAQs on reverse for more information on
                the <KabbageCard />.
              </li>
            )}
            <li className="no-decimal">
              Credit lines and pricing are subject to periodic review and
              change, including line and pricing reductions, line and pricing
              increases, or line eliminations. Individual requests for capital
              are separate installment loans. All loans are subject to credit
              approval.{' '}
              <a href="https://help.kabbage.com/">
                Frequently Asked Questions.
              </a>
            </li>
            {// plpId 32485 refers to alibaba
            plpId === 32485 && (
              <li className="no-decimal two-star">
                Customers who apply for a <KabbageSimple /> line of credit using{' '}
                <a href="https://partner.kabbage.com/alibaba/">
                  partner.kabbage.com/alibaba
                </a>{' '}
                and are approved will receive a $300 Visa&reg; e-gift card via
                email 3-4 weeks after getting approved. The Visa e-gift card can
                be used online wherever Visa debit is accepted.{' '}
                <KabbageSimple /> reserves the right to cancel the promotion at
                any time. This offer is single-use and non-transferrable. Valid
                in the US only.
              </li>
            )}
          </>
        );

        return (
          <section className="footnotes">
            <div className="two-column">
              <div className="column left-column">
                <h3>Footnotes</h3>
              </div>
              <div className="column right-column">
                <h2>
                  <a href="#" className="scrollToTop" onClick={handleClick}>
                    Back To Top
                  </a>
                </h2>
              </div>
            </div>
            <div className="column">
              <ol className={cx({ [styles.sba]: isSbaTemplate })}>
                {isSbaTemplate ? (
                  <>
                    <li>
                      *At this time, Kabbage is offering Paycheck Protection
                      Program (&quot;Program&quot;) loans directly as an
                      approved U.S. Small Business Administration
                      (&quot;SBA&quot;) lender and indirectly on behalf of one
                      or more approved lenders. Loan agreements will identify
                      the lender to small businesses at signing, and any loan
                      made under the Program must also be submitted to and
                      approved by the SBA. Program funds are limited. Kabbage
                      does not guarantee that applications will be processed and
                      submitted before Program funding is no longer available.
                      There is no cost to you to apply for a Program loan. There
                      is no limit to the number of lenders you can apply with,
                      but you can only receive one PPP loan.
                    </li>
                  </>
                ) : (
                  defaultListItems
                )}
              </ol>
              {!isSbaTemplate && (
                <p className="footer-spelling">
                  <KabbageSimple />
                  &mdash;not Cabbage&mdash;makes managing small business
                  finances easy.
                </p>
              )}
            </div>
          </section>
        );
      }}
    </PlpContext.Consumer>
  );
};

export default Footnotes;
